import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { PDFExport } from '@progress/kendo-react-pdf';

const ExpensesTable = React.forwardRef(({ data, sortData, setData, onDelete, searchTerm }, ref) => {
    const [order, setOrder] = useState('asc');
    const [filterResult, setFilterResult] = useState([]);

    const onSort = (col) => {
        if (order === 'asc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] > b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('desc');
        }
        if (order === 'desc') {
            const sorted = [...sortData].sort((a, b) =>
                a[col] < b[col] ? 1 : -1
            );
            setData(sorted);
            setOrder('asc');
        }
    };

    useEffect(() => {
        const filtered = data.filter(data => data.category.toLowerCase().includes(searchTerm.toLowerCase()) || data.paid.toLowerCase().includes(searchTerm.toLowerCase()) || data.mode.toLowerCase().includes(searchTerm.toLowerCase()) || data.bank.toLowerCase().includes(searchTerm.toLowerCase()) || data.billRef.toString().toLowerCase().includes(searchTerm.toLowerCase()) || data.remarks.toLowerCase().includes(searchTerm.toLowerCase()));

        setFilterResult(filtered);
    }, [searchTerm, data]);


    return (
        <div className="flex flex-col">
            <div className="overflow-x-auto mx-2">
                <div className=" pt-8 lg:py-2 inline-block min-w-full px-2 sm:px-4 lg:px-6">
                    <div className="overflow-hidden">
                        <PDFExport paperSize="A4" fileName="dashboard" scale={0.6} avoidLinks={true} landscape={true} ref={ref}>
                            <table className="min-w-full border text-center" id='table-to-xls'>
                                <thead className="border-b">
                                    <tr>
                                        <th scope="col" className="table_head" onClick={() => onSort('Sno')}>
                                            Sno<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('category')}>
                                            Category<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('paid')}>
                                            Paid_to<i className="fa-solid fa-sort ml-1 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('amount')}>
                                            Amount<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('eDate')}>
                                            Expense date<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('mode')}>
                                            Mode<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('check')}>
                                            Check no/Date
                                            <i className="fa-solid fa-sort ml-1 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('bank')}>
                                            Bank<i className="fa-solid fa-sort ml-2 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('billRef')}>
                                            Bill/Ref.No<i className="fa-solid fa-sort ml-1 text-xs opacity-50"></i>
                                        </th>
                                        <th scope="col" className="table_head" onClick={() => onSort('remarks')}>
                                            Remarks
                                        </th>
                                        <th scope="col" className="table_head">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                {filterResult.length > 0 ? (filterResult.map((item, index) => <tbody key={index}>
                                    <tr className="border-b hover:bg-gray-100 animation">
                                        <td className="table_body border-r">
                                            {item.Sno}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.category}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.paid}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.amount}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.edate}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.mode}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.cheque}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.bank}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.billRef}
                                        </td>
                                        <td className="table_body border-r">
                                            {item.remarks}
                                        </td>
                                        <td className="table_body border-r">
                                            <div className='flex items-center justify-center  gap-2'>
                                                <Link to="/admin/expenses/edit" className='link bg-blue-600 text-white h-7 w-7 leading-7 rounded-sm text-center cursor-pointer hover:bg-blue-700 animation'>
                                                    <i className="fa-regular fa-pen-to-square"></i>
                                                </Link>
                                                <button className='bg-red-500 text-white h-7 w-7 rounded-sm text-center cursor-pointer leading-7 hover:bg-red-600 animation' onClick={() => onDelete(item)}>
                                                    <i className="fa-regular fa-trash-can"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>)) : <tbody><tr><td colSpan="100%" className='py-3 text-sm text-gray-800'>No Data Available</td></tr></tbody>}
                            </table>
                        </PDFExport>
                    </div>
                </div>
            </div>
        </div >
    )
});

export default ExpensesTable;